export const NAME = "decideContentOrderProvider";
export const MODAL_NAME = "decideContentOrderProviderModal";
